import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppBreadcrumbModule } from '@coreui/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { AppMaterialModule } from '../../../app-material/app-material.module';
import { ToolbarModule } from '../../../core-components/toolbar copy/toolbar.module';
import { DatePickerComponent } from './date-picker.component';



@NgModule({
  declarations: [DatePickerComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    AppMaterialModule,
    TranslateModule,
    AppBreadcrumbModule,
    BreadcrumbModule,
    ToolbarModule,
    NgxDaterangepickerMd
  ],
  exports: [DatePickerComponent]
})
export class DatePickerModule { }
